// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Belt_Int = require("rescript/lib/js/belt_Int.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var ImportEnrichmentCondition$ReactHooksTemplate = require("./ImportEnrichmentCondition.res.js");
var ImportEnrichmentFieldOptions$ReactHooksTemplate = require("./ImportEnrichmentFieldOptions.res.js");
var ImportEnrichmentActionHelpers$ReactHooksTemplate = require("./ImportEnrichmentActionHelpers.res.js");
var ImportEnrichmentPatternCatalog$ReactHooksTemplate = require("./ImportEnrichmentPatternCatalog.res.js");

function hasText(value) {
  return value.trim() !== "";
}

function isRegexValid(pattern, caseSensitive) {
  if (pattern.trim() === "" || pattern.length > 200) {
    return false;
  }
  try {
    var flags = caseSensitive ? "" : "i";
    new RegExp(pattern, flags);
    return true;
  }
  catch (exn){
    return false;
  }
}

function isRegexGroupValid(group) {
  return Belt_Int.fromString(group.trim()) !== undefined;
}

function isConditionValid(row) {
  var match = row.op;
  switch (match) {
    case "matches_format" :
        if (row.path.trim() !== "") {
          return ImportEnrichmentPatternCatalog$ReactHooksTemplate.isValidFormat(row.format);
        } else {
          return false;
        }
    case "blank" :
    case "present" :
        return row.path.trim() !== "";
    case "regex_match" :
        if (row.path.trim() !== "" && row.pattern.trim() !== "") {
          return isRegexValid(row.pattern, row.caseSensitive);
        } else {
          return false;
        }
    default:
      if (row.path.trim() !== "") {
        return row.value.trim() !== "";
      } else {
        return false;
      }
  }
}

function validateForm(name, pipelineFeed, pipelineTrigger, conditions, actions, fieldOptions) {
  var conditionError = Belt_List.getBy(conditions, (function (row) {
          var match = row.op;
          switch (match) {
            case "matches_format" :
                return !ImportEnrichmentPatternCatalog$ReactHooksTemplate.isValidFormat(row.format);
            case "regex_match" :
                return !isRegexValid(row.pattern, row.caseSensitive);
            default:
              return false;
          }
        }));
  var invalidConditionPath = Belt_List.getBy(conditions, (function (row) {
          if (isConditionValid(row)) {
            return !ImportEnrichmentFieldOptions$ReactHooksTemplate.isReadablePath(fieldOptions, row.path);
          } else {
            return false;
          }
        }));
  var actionError = Belt_List.getBy(actions, (function (row) {
          if (row.targetField.trim() === "" || !ImportEnrichmentFieldOptions$ReactHooksTemplate.isWritableTarget(fieldOptions, row.targetKind, row.targetField)) {
            return true;
          }
          var match = row.valueType;
          switch (match) {
            case "Literal" :
                return ImportEnrichmentActionHelpers$ReactHooksTemplate.literalValueIncomplete(fieldOptions, row.targetKind, row.targetField, row.valueLiteral);
            case "CopyPath" :
                if (row.copyPath.trim() === "") {
                  return true;
                } else {
                  return !ImportEnrichmentFieldOptions$ReactHooksTemplate.isReadablePath(fieldOptions, row.copyPath);
                }
            case "LookupTable" :
                if (row.lookupPath.trim() === "" || !ImportEnrichmentFieldOptions$ReactHooksTemplate.isReadablePath(fieldOptions, row.lookupPath)) {
                  return true;
                } else {
                  return !ImportEnrichmentActionHelpers$ReactHooksTemplate.lookupHasValidMappings(ImportEnrichmentActionHelpers$ReactHooksTemplate.parseLookupMapText(row.lookupMapText));
                }
            case "RegexCapture" :
                var pattern = ImportEnrichmentActionHelpers$ReactHooksTemplate.compileExtractPattern(row);
                if (row.regexPath.trim() === "" || !ImportEnrichmentFieldOptions$ReactHooksTemplate.isReadablePath(fieldOptions, row.regexPath) || pattern.trim() === "" || !isRegexValid(pattern, row.regexCaseSensitive)) {
                  return true;
                } else {
                  return !isRegexGroupValid(row.regexGroup);
                }
            case "DateDiffDays" :
                if (row.fromPath.trim() === "" || !ImportEnrichmentFieldOptions$ReactHooksTemplate.isReadablePath(fieldOptions, row.fromPath) || row.toPath.trim() === "") {
                  return true;
                } else {
                  return !ImportEnrichmentFieldOptions$ReactHooksTemplate.isReadablePath(fieldOptions, row.toPath);
                }
            case "Template" :
                if (row.templateText.trim() === "") {
                  return true;
                } else {
                  return Belt_List.length(ImportEnrichmentActionHelpers$ReactHooksTemplate.templateInvalidPaths(fieldOptions, row.templateText)) > 0;
                }
            
          }
        }));
  if (name.trim() === "") {
    return "Rule name is required.";
  }
  if (!pipelineFeed && !pipelineTrigger) {
    return "Select at least one pipeline (Feed import or Survey trigger).";
  }
  if (Belt_List.some(conditions, (function (row) {
            return !isConditionValid(row);
          }))) {
    return "Complete every condition or remove incomplete rows.";
  }
  if (Belt_Option.isSome(conditionError)) {
    return "One or more conditions has an invalid regex pattern.";
  }
  if (Belt_Option.isSome(invalidConditionPath)) {
    return "One or more conditions uses a field that is not in the catalog.";
  }
  if (Belt_List.some(conditions, (function (row) {
            return !ImportEnrichmentCondition$ReactHooksTemplate.isOperatorValid(row.op, ImportEnrichmentCondition$ReactHooksTemplate.fieldKindForPath(row.path, fieldOptions));
          }))) {
    return "One or more conditions uses an operator that is not valid for its field type.";
  }
  if (actionError === undefined) {
    return ;
  }
  if (actionError.targetField.trim() === "") {
    return "Every action needs a target field.";
  }
  if (!ImportEnrichmentFieldOptions$ReactHooksTemplate.isWritableTarget(fieldOptions, actionError.targetKind, actionError.targetField)) {
    return "Every action target must be selected from Data Fields.";
  }
  var match = actionError.valueType;
  switch (match) {
    case "Literal" :
        var match$1 = ImportEnrichmentActionHelpers$ReactHooksTemplate.literalInputKindForTarget(fieldOptions, actionError.targetKind, actionError.targetField);
        if (typeof match$1 !== "object") {
          return "This action is incomplete.";
        } else {
          return "Fixed-value actions with a list field need a value selected.";
        }
    case "CopyPath" :
        return "Copy actions need a source field from the catalog.";
    case "LookupTable" :
        return "Lookup actions need a source field and at least one complete mapping.";
    case "RegexCapture" :
        return "Extract actions need a source field and a valid pattern.";
    case "DateDiffDays" :
        return "Date calculations need both a start and end date field.";
    case "Template" :
        return "Combined text actions need valid text and recognized fields.";
    
  }
}

function isFormValid(name, pipelineFeed, pipelineTrigger, conditions, actions, fieldOptions) {
  return Belt_Option.isNone(validateForm(name, pipelineFeed, pipelineTrigger, conditions, actions, fieldOptions));
}

function isFormDirty(state) {
  if (state.selected.name !== state.formSnapshot.snapName || state.selected.priority !== state.formSnapshot.snapPriority || state.pipelineFeed !== state.formSnapshot.snapPipelineFeed || state.pipelineTrigger !== state.formSnapshot.snapPipelineTrigger || state.conditionMode !== state.formSnapshot.snapConditionMode || Caml_obj.notequal(state.conditions, state.formSnapshot.snapConditions)) {
    return true;
  } else {
    return Caml_obj.notequal(state.actions, state.formSnapshot.snapActions);
  }
}

exports.hasText = hasText;
exports.isRegexValid = isRegexValid;
exports.isRegexGroupValid = isRegexGroupValid;
exports.isConditionValid = isConditionValid;
exports.validateForm = validateForm;
exports.isFormValid = isFormValid;
exports.isFormDirty = isFormDirty;
/* ImportEnrichmentCondition-ReactHooksTemplate Not a pure module */
